import { PartnershipMode } from 'core/agency/Agency';

export type RevenueSharing = {
  revenueSharingId: number;
  partnershipModeId: PartnershipMode;
  effectiveDate: string;
  percentage: number;
  purpose: string | null;
  creator: string | null;
  createTime: string;
  finished: boolean;
};

export type CurrentRevenueSharing = {
  partnershipModeId: PartnershipMode;
  percentage: number;
};

export type RevenueSharingFormData = {
  purpose: string;
  effectiveDate: string;
  isInstant: boolean;
  partnershipModeId: PartnershipMode;
  percentage: number | string;
};

export type RevenueSharingCreateDTO = {
  partnershipModeId: PartnershipMode;
  percentage: number;
  purpose: string;
  isInstant: boolean;
  effectiveDate?: string;
};

// API 的 percentage 是小數比率（0.15），乘 100 會有浮點誤差（0.07 * 100 = 7.000000000000001），DB 最多四位小數，所以收斂到兩位
export const formatPercentageText = (ratio: number): string => `${parseFloat((ratio * 100).toFixed(2))} %`;
